import { OrderedMap } from 'immutable';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton/IconButton';
import { undoActions } from 'app-components/flux/undo';

import store from 'app-components/utils/redux-store';

import * as notificationsActions from './notificationsActions';
import { mkNotification } from './notificationsTypes';

export const dispatchSimpleNotification = (message, props) => {
  const id = uuidv4();
  store.dispatch(notificationsActions.addNotifications(OrderedMap([[id, mkNotification({ id, message, ...props })]])));
};

export const notificationFromUndo = (undo) =>
  mkNotification({
    id: 'toast-message', //  undo.key,
    message: undo.userMessage,
    createdAt: undo.createdAt,
    anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
    snackbarContentProps: {
      action: [
        ...(!undo.actions?.length
          ? []
          : [
              <Button
                id='undo-button'
                key='undo'
                aria-label='undo'
                color='inherit'
                onClick={() => store.dispatch(undoActions.undo(undo))}
              >
                Undo
              </Button>,
            ]),
        <IconButton
          id='close-undo'
          key='close'
          aria-label='Close'
          onClick={() => store.dispatch(undoActions.deleteUndo(undo))}
          size='large'
          color='inherit'
        >
          <CloseIcon />
        </IconButton>,
      ],
      onClose: (event, reason) => {
        if (reason !== 'clickaway') {
          store.dispatch(undoActions.deleteUndo(undo));
        }
      },
    },
  });
